import { all, takeLatest } from "redux-saga/effects";
import { types as modalsAnchorActions } from "@/bit/reducers/reducers.modals-reducer";
import { types as headerActions } from "@/bit/reducers/reducers.header-reducer";
import { types as mainActions } from "@/bit/reducers/reducers.main-reducer";
import { types as devicesActions } from "@/reducers/devices";
import { initAnchorModalListener, addModal } from "@/bit/sagas/sagas.modals-saga";
import { getSearcherInfo, getRelatedPages } from "@/bit/sagas/sagas.header-saga";
import { checkCPAndSetZones } from "@/bit/sagas/sagas.main-saga";
import { getDevices } from "@/sagas/devices";
import { types as trackingTypes } from "@/bit/reducers/reducers.tracking-reducer";
import * as trackingSagas from "./tracking-saga";

function* rootSaga() {
  yield all([
    takeLatest(
      modalsAnchorActions.INIT_ANCHOR_MODAL_LISTENER,
      initAnchorModalListener
    ),
    takeLatest(modalsAnchorActions.ADD_MODAL, addModal),
    //searcher
    takeLatest(headerActions.GET_SEARCHER_INFO, getSearcherInfo),
    takeLatest(headerActions.GET_RELATED_PAGES, getRelatedPages),
    //cp
    takeLatest(mainActions.CHECK_CP_AND_SET_ZONES, checkCPAndSetZones),
    //tradeIn
    takeLatest(devicesActions.GET_DEVICES, getDevices),
    // tracking
    takeLatest(
      trackingTypes.ORDER_DETAILS_TRACKING_BEGINS,
      trackingSagas.getOrderDetails
    ),
    takeLatest(trackingTypes.GET_LIST_TRACKING_BEGINS, trackingSagas.getListTracking),
    takeLatest(trackingTypes.GET_DETAIL_TRACKING_BEGINS, trackingSagas.getDetailTracking),
    takeLatest(
      trackingTypes.GET_SLOTS_TRACKING_BEGINS,
      trackingSagas.getSlotsTracking
    ),
    takeLatest(
      trackingTypes.POST_MODIFY_APPOINTMENT_TRACKING_BEGINS,
      trackingSagas.postModifyAppointment
    ),
  ]);
}

export default rootSaga;
